import React from 'react';
import { Fab, Zoom } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Icon from '../../Icon';

interface FilesExplorerScrollToTopButtonProps {
	scrollToRef: React.RefObject<HTMLDivElement | null>;
	scrollContainerRef: React.RefObject<HTMLDivElement | null>;
}

export default function FilesExplorerScrollToTopButton({
	scrollToRef,
	scrollContainerRef
}: FilesExplorerScrollToTopButtonProps) {
	const theme = useTheme();

	const [isVisible, setIsVisible] = React.useState(false);

	const scrollToTop = () => {
		scrollToRef.current?.scrollIntoView({ behavior: 'smooth' });
	};

	React.useEffect(() => {
		if (scrollContainerRef.current?.parentNode) {
			const node = scrollContainerRef.current?.parentNode;
			node.addEventListener('scroll', e => {
				if ((e.target as HTMLElement).scrollTop > 300) {
					setIsVisible(true);
				} else {
					setIsVisible(false);
				}
			});
		}
	}, [scrollContainerRef]);

	const transitionDuration = {
		enter: theme.transitions.duration.enteringScreen,
		exit: theme.transitions.duration.leavingScreen
	};

	return (
		<div className="fixed bottom-0 right-0 z-999 m-16">
			<Zoom
				in={isVisible}
				timeout={transitionDuration}
				style={{
					transitionDelay: `${isVisible ? transitionDuration.exit : 0}ms`
				}}
				unmountOnExit
			>
				<Fab color="primary" onClick={scrollToTop}>
					<Icon icon="arrow-up-thick" />
				</Fab>
			</Zoom>
		</div>
	);
}
